import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IQConnectDeviceComponent } from './iq-connect-device.component';
import { GuageModule } from 'src/app/controls/guage/guage.module';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';



@NgModule({
  declarations: [IQConnectDeviceComponent],
  imports: [
    CommonModule,
    IonicModule,
    GuageModule,
    TranslatePipe, TranslateDirective
  ],
  exports:[
    IQConnectDeviceComponent
  ]
})
export class IQConnectDeviceModule { }



